import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { ILanguageResource } from "../types";

export interface ILanguageQueryParameters {
    language?: RelationalValue<ILanguageResource>;
}

export type ILanguageQueryResult = ILanguageResource;

export const languageQuery: IApiQueryFunction<ILanguageQueryParameters> = ({ language }) => {
    if (!language) {
        return;
    }

    return {
        method: "GET",
        url: `/languages/${mapRelationalValue(language)}`,
    };
};

export const useLanguageQuery = createApiQueryHook<ILanguageQueryParameters, ILanguageQueryResult>(languageQuery);
